import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './authentication/auth.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class BaseApiInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      !request.headers.get('Authorization') &&
      (request.url.includes(environment.UpsApiEndpoint) ||
        request.url.includes(environment.EliotApiEndpoint))
    ) {
      request = request.clone({
        headers: request.headers.append(
          'Authorization',
          `Bearer <${this.authService.accessToken}>`
        ),
      });
    }

    let handle: Observable<HttpEvent<any>> = next.handle(request);

    return handle.pipe(
      catchError((response) => {
        if (response.status === 401) {
          this.authService.tryRefreshToken();
          return handle;
        }

        return handle;
      })
    );
  }
}
